// email state
// https://coda.io/d/Backend-Docs_dMWssUbfZKE/State-Code_sunHz

// default sender email
export const DEFAULT_SENDER_EMAIL = 'no-reply@funevent.net';

// 草稿選擇的 action state
export const EMAIL_TYPE = {
  sketch: 0, // 草稿
  reserve: 1, // 預定發送
  send: 2, // 立即發送
};
// 草稿寄件狀態
export const EMAIL_SEND_STATE = {
  notYet: 0, // 未發送
  sent: 1, // 已發送
  sentFailure: 2, // 發送失敗
};
export const EMAIL_RECEIVER_STATE = {
  notYet: 0, // 未發送
  sent: 1, // 發送中
  sentFailure: 2, // 發送失敗
  arrived: 3, // 已送達
  finished: 7, // 完成
};
/**
 * 信件發送失敗時，出現的 error code
 * 預設值: null
 */
export const EMAIL_ERROR_CODE = {
  noError: null, // default value
  pointNotEnough: 0, // 點數不足
  sentFailure: 1, // 發送失敗
  invalidFormat: 2, // 格式錯誤
  mailserverError: 7, // mailServer 錯誤
};
